__turbopack_context__.v({
  "active": "gKZeCG_active",
  "content": "gKZeCG_content",
  "title": "gKZeCG_title",
});
